import styled from "styled-components";
import { Card, Typography } from "antd";
import colors from "constants/colors";

const { Title, Paragraph } = Typography;

export const StyledCard = styled(Card)`
  width: 195px;
  height: 330px;
  position: relative;
  background: transparent;
  border: none;
`;

export const StyledImage = styled.img`
  width: 100%;
  height: 195px;
  border-radius: 10px;
  object-fit: cover;
`;

export const StyledTitleMemberName = styled(Title)`
  padding-top: 1em;
  line-height: 130% !important;
  white-space: initial;
`;

export const StyledParagraphMemberRole = styled(Paragraph)`
  line-height: 1;
`;

export const StyledParagraphMemberContact = styled(Paragraph)`
  font-size: 0.9em;
  a {
    :hover {
      color: ${colors.blue};
    }
  }
`;
